import { useGraphQLQuery } from '@betterment/graphql';

import { CurrentAdvisorDocument, CurrentAdvisorQuery } from '../graphql/query.currentAdvisor.generated';

type UseCurrentAdvisorResult = {
  currentAdvisor: CurrentAdvisorQuery['currentAdvisor'] | null;
};

export const useCurrentAdvisor = (): UseCurrentAdvisorResult => {
  const { data } = useGraphQLQuery(CurrentAdvisorDocument, { fetchPolicy: 'cache-first', throwOnError: true });

  return {
    currentAdvisor: data?.currentAdvisor ?? null,
  };
};
